import { UPDATE_COMPANY } from "../constants";

const initialState = null;

export const setCompanyData = (data) => ({
    type: UPDATE_COMPANY,
    data,
});

export const company = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_COMPANY:
            return action.data;
        default:
            return state;
    }
};